(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9994],{

/***/ 65379:
/***/ (function(module) {

"use strict";
/* global FileReader */



module.exports = function fileToArrayBuffer (file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()

    reader.onerror = function onerror (ev) {
      reject(ev.target.error)
    }

    reader.onload = function onload (ev) {
      resolve(ev.target.result)
    }

    reader.readAsArrayBuffer(file)
  })
}


/***/ }),

/***/ 78854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ AttachedFile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/file-to-array-buffer/index.js
var file_to_array_buffer = __webpack_require__(65379);
var file_to_array_buffer_default = /*#__PURE__*/__webpack_require__.n(file_to_array_buffer);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./utils/uploadUtils.js




var uploadFile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(signed_url, file, onUploadProgress) {
        var buffer, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        file_to_array_buffer_default()(file)
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        4,
                        api/* API.uploadFile */.b.uploadFile(signed_url, buffer, onUploadProgress)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error in the uploadFile function", {
                        error: error
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadFile(signed_url, file, onUploadProgress) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/styles.module.scss
var styles_module = __webpack_require__(18584);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx











var AttachedFile = function(props) {
    var _currentFile = props.currentFile, file = _currentFile.file, signedUrl = _currentFile.signedUrl, handleOnUnpinFile = props.handleOnUnpinFile, updateSelectedFileInfo = props.updateSelectedFileInfo;
    var ref = (0,react.useState)(false), isFileUploaded = ref[0], setIsFileUploaded = ref[1];
    var isMobile = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    (0,react.useEffect)(function() {
        if (isFileUploaded) return;
        uploadFile(signedUrl, file, function() {
            updateSelectedFileInfo(signedUrl);
            setIsFileUploaded(true);
        });
    }, [
        isFileUploaded,
        file,
        signedUrl,
        updateSelectedFileInfo, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).file,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: isMobile ? (0,lodash.truncate)(file.name, {
                    length: 20
                }) : file.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: (0,helper/* getConvertedFileSize */.IJ)(file.size)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                style: {
                    backgroundImage: "url(".concat(helper/* staticImagesUrls.unpinFile */.A6.unpinFile, ")")
                },
                "data-file-name": file.name,
                type: "button",
                onClick: handleOnUnpinFile,
                disabled: !isFileUploaded,
                "aria-label": "Unpin"
            })
        ]
    }, "file/".concat(file.name));
};
AttachedFile.propTypes = {
    currentFile: prop_types_default().shape({
        file: prop_types_default().instanceOf(Object).isRequired,
        signedUrl: (prop_types_default()).string.isRequired
    }).isRequired,
    handleOnUnpinFile: (prop_types_default()).func.isRequired,
    updateSelectedFileInfo: (prop_types_default()).func.isRequired
};


/***/ }),

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./UI/components/TextField/styles.module.scss
var styles_module = __webpack_require__(91979);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/TextField/utils/useProps.js








/* harmony default export */ function useProps(props) {
    var textarea = props.textarea, style = props.style, classNameProp = props.className, errorMessage = props.errorMessage, attached = props.attached, register = props.register, name = props.name, placeholder = props.placeholder, type = props.type, required = props.required, minLength = props.minLength, maxLength = props.maxLength, rows = props.rows, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "textarea",
        "style",
        "className",
        "errorMessage",
        "attached",
        "register",
        "name",
        "placeholder",
        "type",
        "required",
        "minLength",
        "maxLength",
        "rows"
    ]);
    var Component = textarea ? "textarea" : "input";
    var inputRef = (0,react.useRef)(null);
    var inputRegister = register && register(name, {
        required: required,
        pattern: {
            value: type === "email" && /\S+@\S+\.\S+/
        },
        minLength: minLength,
        maxLength: maxLength
    });
    var _obj;
    var className = classnames_default()(classNameProp, (styles_module_default()).input, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).attached, attached), _obj));
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps, inputRegister), {
        required: required,
        placeholder: placeholder,
        type: type,
        tabIndex: "0",
        rows: rows || 1,
        ref: register ? function(el) {
            inputRegister.ref(el);
            inputRef.current = el;
        } : inputRef
    });
    (0,react.useEffect)(function() {
        if (textarea && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) (0,autosize_esm/* default */.Z)(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    }, [
        textarea
    ]);
    return {
        Component: Component,
        className: className,
        options: options,
        errorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./UI/components/TextField/index.jsx





var TextField = function(props) {
    var ref = useProps(props), Component = ref.Component, className = ref.className, options = ref.options, errorMessage = ref.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        role: "textbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, options)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).error,
                tabIndex: "-1",
                children: errorMessage
            })
        ]
    });
};
TextField.defaultProps = {
    type: "text",
    errorMessage: "Fill empty field"
};
TextField.propTypes = {
    register: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    value: (prop_types_default()).func,
    style: (prop_types_default()).string,
    textarea: (prop_types_default()).bool,
    required: (prop_types_default()).bool,
    type: (prop_types_default()).string,
    name: (prop_types_default()).string,
    placeholder: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string,
    pattern: (prop_types_default()).string,
    errorMessage: (prop_types_default()).string,
    attached: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number
};
/* harmony default export */ var components_TextField = (TextField);


/***/ }),

/***/ 9994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Cta; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};



;// CONCATENATED MODULE: ./UI/components/Modal/model/useModal.js

var useModal = create(function(set) {
    return {
        open: false,
        onOpen: function() {
            set({
                open: true
            });
        },
        onClose: function() {
            set({
                open: false
            });
        }
    };
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./UI/components/Modal/ui/styles.module.scss
var styles_module = __webpack_require__(6497);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Modal/ui/Modal.jsx







var Modal = function(param) {
    var open = param.open, children = param.children, onClose = param.onClose, className = param.className;
    (0,react.useEffect)(function() {
        var handleEscape = function(event) {
            if (event.key === "Escape") {
                onClose();
            }
        };
        if (open && "object" !== "undefined") {
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "15px";
            window.addEventListener("keydown", handleEscape);
            return function() {
                document.body.style.overflow = "auto";
                document.body.style.paddingRight = "0";
                window.removeEventListener("keydown", handleEscape);
            };
        }
    }, [
        open,
        onClose, 
    ]);
    if (false) {}
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default()).backdrop, (0,_define_property/* default */.Z)({}, (styles_module_default()).open, open)),
        onClick: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: function(e) {
                return e.stopPropagation();
            },
            className: classnames_default()((styles_module_default()).modal, (0,_define_property/* default */.Z)({}, (styles_module_default()).open, open), className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: onClose,
                    className: (styles_module_default())["close-button"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                        type: "xClose",
                        className: (styles_module_default()).icon
                    })
                }),
                children
            ]
        })
    }), document.body);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./UI/components/TextField/index.jsx + 1 modules
var TextField = __webpack_require__(79228);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx + 1 modules
var AttachedFile = __webpack_require__(78854);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
;// CONCATENATED MODULE: ./UI/components/ContactForm/model/prices.js
var PRICES = {
    0: "20-50k",
    1: "50-100k",
    2: "100-500K",
    3: "500-1,000k",
    4: "> 1,000K"
};

// EXTERNAL MODULE: ./UI/components/ContactForm/ui/styles.module.scss
var ui_styles_module = __webpack_require__(94474);
var ui_styles_module_default = /*#__PURE__*/__webpack_require__.n(ui_styles_module);
;// CONCATENATED MODULE: ./UI/components/ContactForm/ui/Prices.jsx






var PriceSelector = function(param) {
    var setValue = param.setValue;
    var ref = (0,react.useState)(null), selectedPrice = ref[0], setPrice = ref[1];
    var handleSelect = function(value) {
        setValue("price", value);
        setPrice(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (ui_styles_module_default())["prices-title"],
                children: "Your budget (USD)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ui_styles_module_default())["price-list"],
                children: Object.keys(PRICES).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return handleSelect(PRICES[key]);
                        },
                        className: classnames_default()((ui_styles_module_default()).price, (0,_define_property/* default */.Z)({}, (ui_styles_module_default()).checked, selectedPrice === PRICES[key])),
                        children: PRICES[key]
                    }, key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./UI/components/ContactForm/ui/FormAlert.jsx







var FormAlert = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), _ = ref[0], isSuccess = ref[1].isSuccess;
    var onClose = useModal().onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ui_styles_module_default())["form-alert"], (0,_define_property/* default */.Z)({}, (ui_styles_module_default()).onSuccess, isSuccess)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "\uD83D\uDE4C Thanks!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We have received your request. We will back in a flash⚡."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (ui_styles_module_default())["close-button"],
                onClick: onClose,
                children: "Got it!"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./UI/components/ContactForm/model/use-upload.js





/* harmony default export */ function use_upload(props) {
    var setFiles = props.setFiles, selectedFiles = props.selectedFiles;
    var handleFilesChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var files, arrFiles, i, ref, signedUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        files = param.target.files;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        arrFiles = [];
                        i = 0;
                        _state.label = 2;
                    case 2:
                        if (!(i < files.length)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            api/* API.getFileSignedURL */.b.getFileSignedURL(files[i].name)
                        ];
                    case 3:
                        ref = _state.sent(), signedUrl = ref.data;
                        arrFiles.push({
                            file: files[i],
                            signedUrl: signedUrl,
                            isUploaded: false
                        });
                        _state.label = 4;
                    case 4:
                        i += 1;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        setFiles((0,_to_consumable_array/* default */.Z)(selectedFiles).concat((0,_to_consumable_array/* default */.Z)(arrFiles)));
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error("Error in the handleOnSelectedFilesChange function", {
                            error: error
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectedFiles,
        setFiles, 
    ]);
    var handleOnUnpinFile = function(param) {
        var dataset = param.target.dataset;
        setFiles(selectedFiles.filter(function(selectedFile) {
            return selectedFile.file.name !== dataset.fileName;
        }));
    };
    var updateSelectedFileInfo = function(signedUrl) {
        var filesArray = selectedFiles.map(function(file) {
            if (file.signedUrl === signedUrl) {
                file.isUploaded = true;
            }
            return file;
        });
        setFiles((0,_to_consumable_array/* default */.Z)(filesArray));
    };
    return {
        selectedFiles: selectedFiles,
        handleFilesChange: handleFilesChange,
        handleOnUnpinFile: handleOnUnpinFile,
        updateSelectedFileInfo: updateSelectedFileInfo
    };
};

;// CONCATENATED MODULE: ./UI/components/ContactForm/ui/ContactForm.jsx



















var ContactForm = function(param) {
    var onClose = param.onClose, title = param.title, description = param.description, open = param.open;
    var ref = (0,react.useState)([]), selectedFiles = ref[0], setFiles = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), sendForm = ref1[0], ref2 = ref1[1], isSuccess = ref2.isSuccess, isLoading = ref2.isLoading, isError = ref2.isError;
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, reset = ref3.reset, setValue = ref3.setValue, getValues = ref3.getValues, dirtyFields = ref3.formState.dirtyFields;
    var ref4 = use_upload({
        setFiles: setFiles,
        selectedFiles: selectedFiles
    }), handleFilesChange = ref4.handleFilesChange, handleOnUnpinFile = ref4.handleOnUnpinFile, updateSelectedFileInfo = ref4.updateSelectedFileInfo;
    var submitHandler = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, event) {
            var attachments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        attachments = selectedFiles.map(function(file) {
                            return file.signedUrl;
                        });
                        return [
                            4,
                            sendForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                attachments: attachments,
                                projectBudget: values.price || "",
                                description: values.description
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (isSuccess) {
                            setFiles([]);
                            reset();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(values, event) {
            return _ref.apply(this, arguments);
        };
    }());
    (0,react.useEffect)(function() {
        if (!open) {
            reset();
        }
    }, [
        open,
        reset, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: classnames_default()((ui_styles_module_default()).form, (0,_define_property/* default */.Z)({}, (ui_styles_module_default()).onSuccess, isSuccess)),
                onSubmit: submitHandler,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (ui_styles_module_default())["form-title"],
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ui_styles_module_default())["form-description"],
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "name",
                        register: register,
                        placeholder: "Name *",
                        errorMessage: "Required field",
                        required: dirtyFields.name,
                        className: (ui_styles_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "phone",
                        register: register,
                        placeholder: "Phone number",
                        errorMessage: "Incorrect phone number",
                        type: "tel",
                        className: (ui_styles_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "email",
                        register: register,
                        placeholder: "Email *",
                        errorMessage: "Incorrect email address",
                        required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.email,
                        type: "email",
                        className: (ui_styles_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "description",
                        register: register,
                        placeholder: "Description *",
                        errorMessage: "Required field",
                        required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.description,
                        className: (ui_styles_module_default()).input,
                        rows: 3,
                        textarea: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSelector, {
                        register: register,
                        setValue: setValue,
                        getValues: getValues
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ui_styles_module_default()).uploadFile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "file-input",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                    type: constants/* SVG_IMAGES_TYPES.attachment */.NL.attachment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Attach file"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "file-input",
                                    type: "file",
                                    onChange: handleFilesChange,
                                    multiple: true,
                                    className: (ui_styles_module_default()).hide
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ui_styles_module_default())["form-footer"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                className: (ui_styles_module_default())["cancel-button"],
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                className: (ui_styles_module_default())["submit-button"],
                                disabled: isLoading,
                                children: "Send message"
                            })
                        ]
                    }),
                    isError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ui_styles_module_default())["error-message"],
                        children: "There was an error trying to send your message. Please try again later"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ui_styles_module_default()).attachedFiles,
                        children: [
                            selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.map(function(file) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachedFile/* AttachedFile */.s, {
                                    handleOnUnpinFile: handleOnUnpinFile,
                                    currentFile: file,
                                    updateSelectedFileInfo: updateSelectedFileInfo
                                }, file.signedUrl);
                            }),
                            selectedFiles && !!(selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ui_styles_module_default()).moreFilesLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "file-input-more",
                                    children: [
                                        "add more files",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "file-input-more",
                                            type: "file",
                                            onChange: handleFilesChange,
                                            multiple: true,
                                            className: (ui_styles_module_default()).hide
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAlert, {})
        ]
    });
};

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/Cta/styles.module.scss
var Cta_styles_module = __webpack_require__(10748);
var Cta_styles_module_default = /*#__PURE__*/__webpack_require__.n(Cta_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Cta/index.jsx






var Cta = function(param) {
    var section = param.section;
    var ref = useModal(), open = ref.open, onOpen = ref.onOpen, onClose = ref.onClose;
    var contentModules = (0,helper/* getDocumentFields */.OA)(section, [
        "contentModules"
    ]).contentModules;
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", {}), [
        "title",
        "description",
        "imagesBundle",
        "buttonTitle", 
    ]), title = ref1.title, description = ref1.description, imagesBundle = ref1.imagesBundle, buttonTitle = ref1.buttonTitle;
    var file = get_default()(imagesBundle, "[0]", {});
    var background = (0,helper/* getFileUrl */.qm)(file);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Cta_styles_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Cta_styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Cta_styles_module_default()).cta,
                    style: {
                        backgroundImage: "url(".concat(background, ")")
                    },
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: (Cta_styles_module_default())["cta-title"],
                            children: title
                        }),
                        buttonTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: onOpen,
                            className: (Cta_styles_module_default())["cta-button"],
                            children: buttonTitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                open: open,
                onClose: onClose,
                className: (Cta_styles_module_default())["contact-form-modal"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
                    title: title,
                    description: description,
                    open: open,
                    onClose: onClose
                })
            })
        ]
    });
};
/* harmony default export */ var sections_Cta = (Cta);


/***/ }),

/***/ 94474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Vjs1Z","onSuccess":"styles_onSuccess__ZuX6J","form-title":"styles_form-title__aUh_5","form-description":"styles_form-description__FW1eC","uploadFile":"styles_uploadFile__npk6h","form-footer":"styles_form-footer__hG_Rr","cancel-button":"styles_cancel-button__Lhf2h","submit-button":"styles_submit-button__rDz5T","input":"styles_input__MLgdI","price-list":"styles_price-list__KH_4e","price":"styles_price__vEAaW","checked":"styles_checked__D8_Uc","prices-title":"styles_prices-title__w2EWr","attachedFiles":"styles_attachedFiles__H54zW","moreFilesLink":"styles_moreFilesLink__7Aip_","hide":"styles_hide__1AAr_","form-alert":"styles_form-alert__TIBvb","close-button":"styles_close-button__Jgu3C","error-message":"styles_error-message__d91eW"};

/***/ }),

/***/ 18584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"file":"styles_file__Wn8Kr","uploading":"styles_uploading__cx3iV","successUploading":"styles_successUploading__Wg3zy"};

/***/ }),

/***/ 6497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"styles_backdrop__D6Cg2","open":"styles_open__M2Fv4","modal":"styles_modal__LnhPG","close-button":"styles_close-button__1_sSL","icon":"styles_icon__kV4d1"};

/***/ }),

/***/ 91979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__B8LQP","error":"styles_error__6v2ur","attached":"styles_attached__j_Fm3"};

/***/ }),

/***/ 10748:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__CoM7h","container":"styles_container__q9ByU","cta":"styles_cta__YGsB_","cta-title":"styles_cta-title__sX_dV","cta-button":"styles_cta-button__0_F9n","contact-form-modal":"styles_contact-form-modal__WPNTb"};

/***/ })

}]);